import { SocketConnection, useChatSocketHandlers } from '@pba/react-chat-core';
import { getCurrentNodeToken } from 'common/services';
import { useUser } from 'features/auth';

const ChatSocket = () => {
  const { nodeUserData } = useUser();
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- we know that the user is logged in and has a token
  const token = getCurrentNodeToken()!;

  useChatSocketHandlers({ currentUserId: nodeUserData._id });

  return <SocketConnection token={token} />;
};

export default ChatSocket;
